export { default } from './freedom-bank';
